import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { PurchasedGoodsAndServices } from "../../../../api";

export const purchasedGoodsAndServicesKeys = {
  locations: () => ["purchasedGoodsAndServicesLocations"],
  productCategories: () => ["productCategories"],
  items: () => ["purchasedProductItems"]
};

export function useGetLocations(config) {
  const { callApi } = useAuth();
  return useQuery(purchasedGoodsAndServicesKeys.locations(),
    () => callApi(PurchasedGoodsAndServices.getLocations), config);
}

export function useGetProductCategoriesPerLocation(params, config) {
  const { callApi } = useAuth();
  return useQuery([...purchasedGoodsAndServicesKeys.productCategories(), params.location],
    () => callApi(PurchasedGoodsAndServices.getProductCategoriesPerLocation, params), {
      ...config,
      enabled: params.location !== "",
      cacheTime: 0
    });
}

export function useGetPurchasedProductItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...purchasedGoodsAndServicesKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(PurchasedGoodsAndServices.getPurchasedProductItems, params), config);
}

export function useAddPurchasedProductItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(PurchasedGoodsAndServices.addPurchasedProductItems, { questionnaireId, data }), config);
}

export function useUpdatePurchasedProductItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(PurchasedGoodsAndServices.updatePurchasedProductItem, { questionnaireId, recordId, data }), config);
}

export function useDeletePurchasedProductItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(PurchasedGoodsAndServices.deletePurchasedProductItem, { questionnaireId, recordId }), config);
}

export function useImportPurchasedProductItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(PurchasedGoodsAndServices.importPurchasedProductItems, { questionnaireId, data }), config);
}

export function useDownloadPurchasedGoodsAndServicesTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) => callApi(PurchasedGoodsAndServices.getTemplate, questionnaireId), config);
}